export function formatDate(dateStr) {
    const date = new Date(dateStr);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (date.toDateString() === today.toDateString())
        return 'Сегодня';
    if (date.toDateString() === tomorrow.toDateString())
        return 'Завтра';
    return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}
export function getDateParam(filter) {
    if (filter === 'today')
        return new Date().toISOString().split('T')[0];
    if (filter === 'tomorrow') {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        return d.toISOString().split('T')[0];
    }
    // Already a YYYY-MM-DD string
    return filter;
}
export function timeAgo(dateStr) {
    const diff = Date.now() - new Date(dateStr).getTime();
    const minutes = Math.floor(diff / 60000);
    if (minutes < 1)
        return 'только что';
    if (minutes < 60)
        return `${minutes} мин`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24)
        return `${hours} ч`;
    return `${Math.floor(hours / 24)} д`;
}
